import React from 'react';

const Textarea = ({
  className,
  name,
  label,
  inputRef,
  errors,
  control,
  watch,
  cols = 30,
  rows = 10,
  ...rest
}) => {
  const msgErro = errors && errors[name]?.message;
  return (
    <div className={`campo ${className ? className : ''}`}>
      <div className="rotulo">
        <label htmlFor="numero">{label}</label>
      </div>
      <div className="controle">
        <textarea
          name={name}
          cols={cols}
          rows={rows}
          className={msgErro ? 'invalid' : ''}
          ref={inputRef}
          {...rest}
        ></textarea>
      </div>
      <div className="mensagem">{msgErro}</div>
    </div>
  );
};

export default Textarea;
